export default __webpack_public_path__ + "static/media/seema-main-image-11.c203ed5c.jpeg";